import { Box, Typography } from "@mui/material";

import { Button, Modal } from "@covertree/ui";

interface RemoveAdditionalInterestConfirmationModalProps {
  readonly isModalOpen: boolean;
  readonly additionalInterestName: string;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
  readonly isSubmitting?: boolean;
}

export function RemoveAdditionalInterestConfirmationModal({
  isModalOpen,
  additionalInterestName,
  onClose,
  onConfirm,
  isSubmitting = false,
}: RemoveAdditionalInterestConfirmationModalProps) {
  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      disableClose={isSubmitting}
      title="Are you sure?"
      maxWidth={false}
      sx={{
        width: { xs: "80%", md: 720 },
        "&:focus": {
          outline: "none",
        },
      }}>
      <Typography
        variant="h5"
        sx={{ pr: 5, color: "text.secondary", textAlign: "justify" }}>
        Do you want to remove this additional interest {additionalInterestName}?
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button
          color="error"
          onClick={onConfirm}
          loading={isSubmitting}
          disabled={isSubmitting}>
          Yes, remove
        </Button>
        <Button variant="outlined" onClick={onClose} disabled={isSubmitting}>
          No, cancel
        </Button>
      </Box>
    </Modal>
  );
}
